import PermissionTypeRepository from "../domain/data/PermissionTypeRepository";
import PermissionType from "../domain/entities/PermissionType";
import User from "../domain/entities/User";
import { permissionTypes } from "./InitData";

export default class MockPermissionTypeRepository implements PermissionTypeRepository{
    async getPermissionTypes(user: User): Promise<PermissionType[]> {
        return permissionTypes;
    }
    
}